<template>
  <div>
    <div class="w-100">
      <v-alert type="info" text class="mb-5">
        Le paramétrage des options ne pourra plus être modifié après le premier envoi de la campagne et s'appliquera aussi à ses relances.
      </v-alert>
    </div>
    <v-card flat>
      <v-card-text>
        <h4 class="mb-5">Options d'envoi</h4>

        <div class="d-flex" v-if="showDisableEmailOption">
          <v-checkbox style="padding: 0 !important; margin: 0 !important;"
                      label="Désactiver l'envoi d'e-mails lors du premier envoi"
                      :input-value="noEmail"
                      @change="setNoEmail"
                      hide-details>
          </v-checkbox>

          <v-tooltip slot="append-outer" bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon>help</v-icon>
              </v-btn>
            </template>
            <span>
                                Cette option désactive l'envoi d'e-mail de la campagne lors du premier envoi.
                                <br>
                                Le professionnel ne recevra pas d'e-mail lors du 1er envoi, mais sera contacté pour les
                                relances
                            </span>
          </v-tooltip>
        </div>

        <div class="d-flex">
          <v-checkbox style="padding: 0 !important; margin: 0 !important;"
                      label="Envoyer un seul e-mail pour un même destinaire"
                      :input-value="singleEmail" @change="setSingleEmail"
                      hide-details>
          </v-checkbox>

          <v-tooltip slot="append-outer" bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon>help</v-icon>
              </v-btn>
            </template>
            <span>
                                Si plusieurs fiches ont le même e-mail : un seul e-mail sera envoyé.
                                <br>
                                Le destinataire aura bien un formulaire pour chaque fiche dans son espace-pro.
                            </span>
          </v-tooltip>
        </div>
      </v-card-text>
    </v-card>

    <v-card v-if="criterias !== undefined && criterias.length" flat>
      <v-card-text>
        <div class="d-flex">
          <h4 class="mb-5">Critères internes</h4>
          <v-tooltip slot="append-outer" right>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon class="align-baseline">
                <v-icon>help</v-icon>
              </v-btn>
            </template>
            <span>
                                  Sélectionnez des critères internes ici, afin qu'ils soient présélectionnés
                automatiquement sur les réponses. <br>
                                 Assurez vous d’avoir au préalable ajouté Dahub
               en tant que Membre collaborateur de vos critères internes sur Apidae.
                            </span>
          </v-tooltip>
        </div>

        <div class="form-container mr-auto ml-auto">
          <v-autocomplete :items="criterias" chips deletable-chips label="Sélectionner vos critères internes"
                          item-text="libelle" item-value="id" hide-details :value="selectedCriterias"
                          @change="setSelectedCriterias" multiple outlined>
          </v-autocomplete>
        </div>
      </v-card-text>
    </v-card>

    <div class="text-right mb-5 mt-5">
      <v-btn class="default-button" @click="setCurrentStep(parseInt(currentStep) + 1)">Passer à l'étape suivante
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
  name: "Options",
  props: ["isRevival", "cadhId", "updateMode", "criterias", "cadh"],
  methods: {
    ...mapMutations("createCadh", ["setCurrentStep", "setSelectedCriterias", "setNoEmail", "setSingleEmail"]),
  },
  computed: {
    ...mapState("createCadh", [
      "noEmail",
      "singleEmail",
      "selectedCriterias",
      'currentStep'
    ]),
    showDisableEmailOption() {
      let show = !this.isRevival

      if (this.cadh) {
        show = show || this.cadh.state.code === "WAIT_FIRST_SENT"
      }

      return show
    },
  },
}
</script>